var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.as,_vm._g(_vm._b({tag:"component",class:[_vm.col ? `col-${_vm.col}` : 'col', _vm.sm && `col-sm-${_vm.sm}`, _vm.md && `col-md-${_vm.md}`, _vm.lg && `col-lg-${_vm.lg}`]},'component',_vm.attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }